angular.module('smartorg.r6.mgmts.createPortfolio').directive("createPortfolio", [function () {
        return {
            restrict: 'E',
            template: require('../../template/create-portfolio.html'),
            transclude: true,
            scope: {
                createPortfolio: '&'
            },
            link: function (scope) {
                scope.$on('manage:SaveNewPortfolio', function () {
                    $('#createPortfolioModal').modal('show');
                });
                scope.portfolioName = "";
                scope.saveNewPortfolio = function () {
                    scope.createPortfolio({
                        newPortfolioName: scope.portfolioName
                    });
                    scope.resetPortfolio();
                };
                scope.resetPortfolio = function () {
                    scope.portfolioName = "";
                };
            }
        };
    }]);
//# sourceMappingURL=create-portfolio-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/create-portfolio/app/js/plumbing/create-portfolio-directive.js